export const DASHBOARD_HEADER_HEIGHT = '82px';